import { lenis } from './lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const home = () => {
	bannerFade()
	bannerParallax()
	selectedProject()
	setTimeout(() => {
		affiliates()
	}, 1000);
}

const bannerFade = () => {

	let els = document.querySelectorAll('[data-animation="home-banner-media"]')

	if (!els.length) return

	els.forEach(el => {
		el.style.opacity = 1
	})

	let el = els[0]

	el.style.opacity = 1

	gsap.fromTo(el, {
		opacity: 0,
		scale: 1.2,
	}, {
		opacity: 1,
		scale: 1,
		delay: 0.4,
		duration: 3,
	})
}

const selectedProject = () => {

	let els = document.querySelectorAll('[data-animation="selected-project"]')

	if (!els.length) return

	els.forEach(el => {
		el.style.opacity = 1
	})

	gsap.fromTo(els, {
		opacity: 0,
	}, {
		opacity: 1,
		duration: 0.6,
		delay: 1,
	})
}

const bannerParallax = () => {

	let el = document.querySelector('[data-animation="home-banner-scroll"]')

	if (!el || window.innerWidth < 782) return

	el.style.opacity = 1

	gsap.fromTo(el, {
		y: 0,
	}, {
		y: 400,
		ease: 'none',
		scrollTrigger: {
			trigger: el.parentElement,
			start: 'top top',
			end: 'bottom top',
			scrub: true,
			// markers: true,
		}
	})
}

const affiliates = () => {

	let el = document.querySelector('[data-animation="affiliates"]')

	if (!el) return

	el.style.opacity = 1

	let outer = el.querySelector('[data-el="outer"]'),
		inner = el.querySelector('[data-el="inner"]')

	let movement = gsap.fromTo(outer, {
		x: 0,
	}, {
		x: '-25%',
		repeat: -1,
		duration: 100,
		ease: 'none',
	})

	movement.seek(1000);

	lenis.on('scroll', () => {
		if (lenis.direction == -1) {
			movement.reverse()
		} else if (lenis.direction == 1) {
			movement.play()
		}
	})

	gsap.fromTo(inner, {
		xPercent: 0,
	}, {
		xPercent: -2,
		ease: 'none',
		scrollTrigger: {
			trigger: el,
			start: 'top bottom',
			end: 'bottom top',
			scrub: true,
		},
	})
}

export default () => { }